export const injectTimeIntoDate = (date: Date, timeStr: string) => {
  const newDate = new Date(date.getTime()); // clone the original date
  const time12hRegex = /^(\d{1,2}):(\d{2})(?:\s?(AM|PM))?$/i;

  const match = timeStr.match(time12hRegex);
  if (!match) {
    throw new Error('Invalid time format');
  }

  let hours = Number.parseInt(match[1], 10);
  const minutes = Number.parseInt(match[2], 10);
  const meridian = match[3]?.toUpperCase();

  if (meridian) {
    // 12-hour format
    if (meridian === 'PM' && hours !== 12) {
      hours += 12;
    } else if (meridian === 'AM' && hours === 12) {
      hours = 0;
    }
  }

  newDate.setHours(hours, minutes, 0, 0);
  return newDate;
};
